import { createAction } from 'redux-actions';
import { createSuccessAction, createFailureAction, createActionBundle } from 'utilities/request';

export const requestUserData = createAction('REQUEST/USER_DATA');
export const requestUserDataSuccess = createSuccessAction(requestUserData);
export const requestUserDataFailure = createFailureAction(requestUserData);

export const userSetData = createAction('USER/SET_DATA');

export const userSetResource = createAction('USER/SET_RESOURCE');

export const userSubmitChangePasswordForm = createAction('USER/SUBMIT_CHANGE_PASSWORD_FORM');

export const {
  request: requestChangePassword,
  success: requestChangePasswordSuccess,
  failure: requestChangePasswordFailure,
} = createActionBundle('CHANGE_PASSWORD');

export const userSubmitFeedbackForm = createAction('USER/SUBMIT_FEEDBACK_FORM');

export const userSubmitNotificationsForm = createAction('USER/SUBMIT_NOTIFICATIONS_FORM');

export const {
  request: requestSendFeedback,
  success: requestSendFeedbackSuccess,
  failure: requestSendFeedbackFailure,
} = createActionBundle('SEND_FEEDBACK');

export const userAcceptAgreement = createAction('USER/ACCEPT_AGREEMENT');

export const requestPutUserData = createAction('REQUEST/PUT_USER_DATA');
